// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__11JEM","cell":"ColumnAccessor_cell__hUFvk","firstCellAccent":"ColumnAccessor_firstCellAccent__3PrnB"};